import React from 'react';
import { Navigate } from 'react-router';

type Props = {
  to: string;
  replace?: boolean;
};

const Redirect: React.FC<Props> = ({ to, replace = true }) => {
  const [redirect, setRedirect] = React.useState(false);

  React.useEffect(() => {
    setRedirect(true);
  }, [to, replace]);

  return redirect ? <Navigate to={to} replace={replace} /> : null;
};

export default Redirect;
